import React, { useState } from "react";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/mock";

export function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? TESTIMONIALS.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === TESTIMONIALS.length - 1 ? 0 : c + 1));

  return (
    <section className="py-20 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-14">
          <span className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase">Testimonials</span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#1a1a1a] mt-2 mb-3">
            What Hyderabad Homeowners Say
          </h2>
          <p className="text-gray-500">Real stories from our happy clients across Hyderabad</p>
        </div>

        {/* Desktop: 3-column grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TESTIMONIALS.map((t) => (
            <TestimonialCard key={t.id} testimonial={t} />
          ))}
        </div>

        {/* Mobile: Carousel */}
        <div className="md:hidden">
          <TestimonialCard testimonial={TESTIMONIALS[current]} />
          <div className="flex justify-center items-center gap-4 mt-6">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#C9A84C] hover:text-[#C9A84C] transition-colors"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-1.5">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-2 h-2 rounded-full transition-all ${i === current ? "bg-[#C9A84C] w-5" : "bg-gray-300"}`}
                />
              ))}
            </div>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#C9A84C] hover:text-[#C9A84C] transition-colors"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial: t }) {
  return (
    <div className="bg-[#FAF8F5] rounded-xl p-6 relative" data-testid={`testimonial-${t.id}`}>
      <Quote size={24} className="text-[#C9A84C]/40 mb-3" />
      <div className="flex gap-0.5 mb-3">
        {[...Array(t.rating)].map((_, i) => (
          <Star key={i} size={13} className="fill-[#C9A84C] text-[#C9A84C]" />
        ))}
      </div>
      <p className="text-gray-600 text-sm leading-relaxed mb-4">{t.text}</p>
      <div className="flex items-center gap-3 mt-auto pt-3 border-t border-gray-200">
        <div className="w-10 h-10 rounded-full bg-[#C9A84C] flex items-center justify-center flex-shrink-0">
          <span className="text-white text-sm font-bold">{t.avatar}</span>
        </div>
        <div>
          <div className="font-semibold text-[#1a1a1a] text-sm">{t.name}</div>
          <div className="text-xs text-gray-400">{t.location}</div>
          <div className="text-xs text-[#C9A84C]">{t.project}</div>
        </div>
      </div>
    </div>
  );
}
